import React, { useEffect, useRef, useState } from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row,
  Card,
  CardText,
  Form,
  CardBody,
  Collapse,
} from "reactstrap";

import ImportCreateSpeaker from "./ImportCreateSpeaker";
import ImportUpdateSpeaker from "./ImportUpdateSpeaker";
import ImportDeleteSpeaker from "./ImportDeleteSpeaker";
import SectionComponent from "../../Apps/Personalization/SectionComponent";

export default function ModalImportWrapper(props) {
  const { isOpen, toggle, idEvent, getAllSpeakers } = props;

  // const [collapseGroupIsOpen, setCollapseGroupIsOpen] = useState(false);
  // const [collapseLoginIsOpen, setCollapseLoginIsOpen] = useState(false);
  const [collapseCreateIsOpen, setCollapseCreateIsOpen] = useState(false);
  const [collapseEditIsOpen, setCollapseEditIsOpen] = useState(false);
  const [collapseDeleteIsOpen, setCollapseDeleteIsOpen] = useState(false);

  const [activeImport, setActiveImport] = useState(false);

  function toggleBackdrop() {
    setCollapseCreateIsOpen(false);
    setCollapseEditIsOpen(false);
    setCollapseDeleteIsOpen(false);
    toggle();
  }
  function toggleCollapseCreate() {
    if (activeImport) return;
    setCollapseEditIsOpen(false);
    setCollapseDeleteIsOpen(false);
    setCollapseCreateIsOpen(!collapseCreateIsOpen);
  }

  function toggleCollapseEdit() {
    if (activeImport) return;
    setCollapseEditIsOpen(!collapseEditIsOpen);
    setCollapseCreateIsOpen(false);
    setCollapseDeleteIsOpen(false);
  }

  function toggleCollapseDelete() {
    if (activeImport) return;
    setCollapseDeleteIsOpen(!collapseDeleteIsOpen);
    setCollapseCreateIsOpen(false);
    setCollapseEditIsOpen(false);
  }

  function activatedImport(status) {
    setActiveImport(status);
  }

  function setNull() {}

  useEffect(() => {
    if (isOpen) {
      toggleBackdrop();
    }
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggleBackdrop()}
      autoFocus={true}
      centered={true}
    >
      <ModalHeader toggle={() => toggleBackdrop()}>
        Importar Palestrantes
      </ModalHeader>
      <ModalBody className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            <div>
              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "245px",
                }}
              >
                <SectionComponent
                  sectionName="Criar Palestrantes"
                  setIsOpen={!activeImport ? toggleCollapseCreate : setNull}
                  isOpen={collapseCreateIsOpen}
                />
              </Row>
              <Collapse isOpen={collapseCreateIsOpen}>
                <ImportCreateSpeaker
                  isOpen={isOpen}
                  toggle={toggleBackdrop}
                  active={activatedImport}
                  getAllSpeakers={getAllSpeakers}
                  // token={token}
                  idEvent={idEvent}
                />
              </Collapse>
            </div>
            <div>
              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "280px",
                }}
              >
                <SectionComponent
                  sectionName="Atualizar Palestrantes"
                  setIsOpen={!activeImport ? toggleCollapseEdit : setNull}
                  isOpen={collapseEditIsOpen}
                />
              </Row>
              <Collapse isOpen={collapseEditIsOpen}>
                <ImportUpdateSpeaker
                  isOpen={isOpen}
                  toggle={toggleBackdrop}
                  active={activatedImport}
                  getAllSpeakers={getAllSpeakers}
                  // token={token}
                  idEvent={idEvent}
                />
              </Collapse>
            </div>
            <div>
              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "280px",
                }}
              >
                <SectionComponent
                  sectionName="Excluir Palestrantes"
                  setIsOpen={!activeImport ? toggleCollapseDelete : setNull}
                  isOpen={collapseDeleteIsOpen}
                />
              </Row>
              <Collapse isOpen={collapseDeleteIsOpen}>
                <ImportDeleteSpeaker
                  isOpen={isOpen}
                  toggle={toggleBackdrop}
                  active={activatedImport}
                  getAllSpeakers={getAllSpeakers}
                  // token={token}
                  idEvent={idEvent}
                />
              </Collapse>
            </div>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
}
